import { createAction, createAsyncAction } from 'typesafe-actions';
import { PhaseInfo, GetPhasesParams, PhaseModalType } from './types';

export const getPhasesAsync = createAsyncAction(
  'phases/GET_PHASES_REQUEST',
  'phases/GET_PHASES_SUCCESS',
  'phases/GET_PHASES_FAILURE',
)<GetPhasesParams, { total: number; data: any[] }, Error>();

export const updatePhaseAsync = createAsyncAction(
  'phases/UPDATE_PHASE_REQUEST',
  'phases/UPDATE_PHASE_SUCCESS',
  'phases/UPDATE_PHASE_FAILURE',
)<PhaseInfo, {}, Error>();

export const addPhaseAsync = createAsyncAction(
  'phases/ADD_PHASE_REQUEST',
  'phases/ADD_PHASE_SUCCESS',
  'phases/ADD_PHASE_FAILURE',
)<PhaseInfo, {}, Error>();

export const deletePhaseAsync = createAsyncAction(
  'phases/DELETE_PHASE_REQUEST',
  'phases/DELETE_PHASE_SUCCESS',
  'phases/DELETE_PHASE_FAILURE',
)<{}, {}, Error>();

export const setPhases = createAction('phases/SET_PHASES')<Array<PhaseInfo>>();
export const setPhaseModalType = createAction('phases/SET_PHASE_MODAL_TYPE')<PhaseModalType>();
export const setSelectedPhase = createAction('phases/SET_SELECTED_PHASE')<PhaseInfo>();
export const setRefreshTable = createAction('phases/SET_REFRESH_TABLE')<boolean>();
